(function() {

    /*
        Reorder navigations items 
    */

    // var navItems = $('.ordered-nav-list'),
    //     parentUL = navItems.parent();

    // for (var i = navItems.length; i>0; i--){
    //     var last_item = parentUL.find('.order_' + i);
    //     parentUL.prepend(last_item);
    // }

    /*
        AJAX - Add To Bag
    */

    Bag.init();

    var addToCartButtons = $('.product .add-to-cart');

    addToCartButtons.on('click', function(e){
        var variantID = $(this).data('variant-id');
        Bag.addItem(variantID);
        e.preventDefault();
    });
    
})();